import React from "react";
import { Link } from "react-router-dom";

import search from "../../public/search.svg";
import search_dark from "../../public/search_dark.svg";

import wheretogo_1 from "../../public/wheretogo-krkonose/wheretogo_1.png";
import wheretogo_2 from "../../public/wheretogo-krkonose/wheretogo_2.png";
import wheretogo_3 from "../../public/wheretogo-krkonose/wheretogo_3.png";
import wheretogo_4 from "../../public/wheretogo-krkonose/wheretogo_4.png";
import wheretogo_5 from "../../public/wheretogo-krkonose/wheretogo_5.png";

import { useContext } from "react";
import { DarkModeContext } from "../../components/DarkModeProvider";

import { useUserContext } from "../../context/userContext";

const KamSeVydatVKrkonosich = () => {
  
  const { user } = useUserContext();

  const { darkMode } = useContext(DarkModeContext);

  return (
    <>
      <section
        className={darkMode ? "where__to--go dark" : "where__to--go light"}
      >
        <div class="container">
          <div class="where__to--go--heading">
            <img src={darkMode ? search_dark : search} alt="" />
            <h1 className={darkMode ? "dark-text" : "light-text"}>
              Kam se vydat v Krkonoších
            </h1>
          </div>
        </div>
      </section>

      <section
        className={
          darkMode ? "where__to--go--main dark" : "where__to--go--main light"
        }
      >
        <div class="container">
          <div class="where__to--go--container">
            <div class="where__to--go--image">
              <img src={wheretogo_1} alt="" />
            </div>
            <div class="where__to--go--content">
              <h3 className={darkMode ? "dark-text" : "light-text"}>Sněžka</h3>
              <p
                className={darkMode ? "dark-second-text" : "light-second-text"}
              >
                Sněžka je se svými 1603 m. n. m. nejvyšší horou Česka. Tento
                vrchol je významná dominanta východní části Krkonoš. Na samotný
                vrchol vede spoustu turistických tras.
              </p>
              <Link
                className={darkMode ? "dark-button-text" : "light-button-text"}
                to="/krkonose/kamsevydat/snezka"
              >
                <span>Více</span>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section
        className={
          darkMode ? "where__to--go--main dark" : "where__to--go--main light"
        }
      >
        <div class="container">
          <div class="where__to--go--container">
            <div class="where__to--go--image">
              <img src={wheretogo_2} alt="" />
            </div>
            <div class="where__to--go--content">
              <h3 className={darkMode ? "dark-text" : "light-text"}>
                Špindlerův Mlýn
              </h3>
              <p
                className={darkMode ? "dark-second-text" : "light-second-text"}
              >
                Špindlerův Mlýn je město v Krkonoších v okrese Trutnov a zároveň
                nejnavštěvovanější horské středisko v Česku. Také se zde točilo
                spousto známých českých filmu jako jsou např.: Jak vytrhnout
                velrybě stoličku a Snowboarďáci
              </p>
              <Link
                className={darkMode ? "dark-button-text" : "light-button-text"}
                to="/krkonose/kamsevydat/spindleruvmlyn"
              >
                <span>Více</span>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section
        className={
          darkMode ? "where__to--go--main dark" : "where__to--go--main light"
        }
      >
        <div class="container">
          <div class="where__to--go--container">
            <div class="where__to--go--image">
              <img src={wheretogo_3} alt="" />
            </div>
            <div class="where__to--go--content">
              <h3 className={darkMode ? "dark-text" : "light-text"}>
                Černá hora
              </h3>
              <p
                className={darkMode ? "dark-second-text" : "light-second-text"}
              >
                Černá hora je hora ve východních Krkonoších, nacházející se 3,5
                km severozápadně nad lázeňským městečkem Janské Lázně a 5 km
                jižně od Pece pod Sněžkou
              </p>
              <Link
                className={darkMode ? "dark-button-text" : "light-button-text"}
                to="/krkonose/kamsevydat/cernahora"
              >
                <span>Více</span>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section
        className={
          darkMode ? "where__to--go--main dark" : "where__to--go--main light"
        }
      >
        <div class="container">

          {user ?
          <div class="where__to--go--container">
            <div class="where__to--go--image">
              <img src={wheretogo_4} alt="" />
            </div>
            <div class="where__to--go--content">
              <h3 className={darkMode ? "dark-text" : "light-text"}>
                Mumlavský vodopád
              </h3>
              <p
                className={darkMode ? "dark-second-text" : "light-second-text"}
              >
                Mumlavský vodopád je necelých 10 metrů vysoký vodopád, který se
                nachází v Harrachovské kotlině na řece Mumlavě v ochranném pásmu
                Krkonošského národního parku. Jeho jméno pochází z německého
                slova murmeln, česky mumlat, což vystihuje zvuk tohoto vodopádu.
              </p>
              <Link
                className={darkMode ? "dark-button-text" : "light-button-text"}
                to="/krkonose/kamsevydat/mumlavskyvodopad"
              >
                <span>Více</span>
              </Link>
            </div>
          </div>
          :
          <div className="where__to--go--container">
            <div className="where__to--go--image where__to--go--container--locked">
              <img src={wheretogo_4} alt="" />
            </div>
            <div className="where__to--go--content where__to--go--container--locked">
              <h3  className={darkMode ? "dark-text " : "light-text"}>Pro registrované</h3>
              <p className={darkMode ? "dark-second-text" : "light-second-text"}>
                  Zaregistrujte se už dnes a získejte přístup k prémiovým místům
              </p>
              <Link className={darkMode ? 'dark-button-text' : 'light-button-text'} to="/profile">
                <span>Více</span>
              </Link>
            </div>
          </div> 
          }
        </div>
      </section>



      <section
        className={
          darkMode ? "where__to--go--main dark" : "where__to--go--main light"
        }
      >
        <div class="container">

          {user ?
          <div class="where__to--go--container">
            <div class="where__to--go--image">
              <img src={wheretogo_5} alt="" />
            </div>
            <div class="where__to--go--content">
              <h3 className={darkMode ? "dark-text" : "light-text"}>Žalý</h3>
              <p
                className={darkMode ? "dark-second-text" : "light-second-text"}
              >
                Žalý, dříve též Heidlova hora, je hora ležící v poslední rozsoše
                Žalského hřbetu ve střední části Krkonoš. Na vrcholu je
                rozhledna, ze které je výborný rozhled na Krkonoše a Podkrkonoší
              </p>
              <Link
                className={darkMode ? "dark-button-text" : "light-button-text"}
                to="/krkonose/kamsevydat/zaly"
              >
                <span>Více</span>
              </Link>
            </div>
          </div>
          :
          <div className="where__to--go--container">
            <div className="where__to--go--image where__to--go--container--locked">
              <img src={wheretogo_5} alt="" />
            </div>
            <div className="where__to--go--content where__to--go--container--locked">
              <h3  className={darkMode ? "dark-text " : "light-text"}>Pro registrované</h3>
              <p className={darkMode ? "dark-second-text" : "light-second-text"}>
                  Zaregistrujte se už dnes a získejte přístup k prémiovým místům
              </p>
              <Link className={darkMode ? 'dark-button-text' : 'light-button-text'} to="/profile">
                <span>Více</span>
              </Link>
            </div>
          </div> 
        }

        </div>
      </section>
    </>
  );
};

export default KamSeVydatVKrkonosich;
